import { FC, useId } from 'react';

import { CurrencyConnected } from '@pp/core/src/components/currency/CurrencyConnected';

import { SingleBetHistoryType } from '../../../../store/slices/highflyerGame/types';
import { SingleMultiplier } from '../../singleMultiplier/SingleMultiplier';

import styles from './BetsHistoryTable.module.css';

interface SingleBetRowProps {
  data: SingleBetHistoryType[] | undefined;
  show: boolean;
}

export const SingleBetRow: FC<SingleBetRowProps> = ({ data, show }) => {
  const id = useId();

  if (!data) return null;

  return data.map((item: SingleBetHistoryType) => {
    const isActive = show ? item.mul > 0 : item.cashOutMultiplier > 0;
    const userName = show ? item.sName : item.nickname;
    const betAmount = show ? item.betAmt : item.betAmount;
    const multiplier = show ? item.mul : item.cashOutMultiplier;
    const winAmount = show ? item.winAmt : item.winAmount;
    return (
      <tr
        key={`betHistoryRow-${id}`}
        className={`${styles.betHistory_body_row} ${isActive && styles.betHistory_body_row_active}`}
      >
        <td className={styles.firstCol}>
          <div className={styles.userName}>{userName}</div>
        </td>
        <td className={styles.secondCol}>
          <CurrencyConnected value={Number(betAmount)} hideCurrency />
        </td>
        <td className={styles.thirdCol}>
          {item.mul > 0 || item.cashOutMultiplier > 0 ? <SingleMultiplier value={Number(multiplier)} /> : <div></div>}
        </td>
        <td className={styles.fourthCol}>
          {item.winAmt > 0 || item.winAmount > 0 ? (
            <div className={styles.winAmt}>
              <CurrencyConnected value={Number(winAmount)} hideCurrency />
            </div>
          ) : (
            <div className={styles.dash}></div>
          )}
        </td>
      </tr>
    );
  });
};
